//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  middleware: ['auth', 'authorizeCustomer'],
  data: function data() {
    return {
      userData: {
        email: 'Jose Birley@pGhJf.com',
        firstName: 'Jose Birley',
        lastName: 'Mortimer Silman',
        createOn: '2018-02-04T15:48:35.000Z',
        updateOn: '2018-02-04T15:48:35.000Z',
        createBy: 'admin',
        createByName: 'sys admin',
        updateBy: 'admin',
        updateByName: 'sys admin',
        lastLogin: '2018-02-04T15:48:35.000Z',
        password: '6vKpL',
        salt: 'iVsqGwu5uduDN1GnkY8t',
        token: 'qsp4F',
        status: 'Active',
        avatar: 'makeid.jpg',
        role: 'Customer',
        phone: '0830416153',
        id: 'C00002',
        customerName: 'Newton Laboratories, Inc.',
        branch: 'Branch 02',
        address1: '9426 Main Hill',
        taxID: 4294967295,
        fax: '0847592071',
        businessType: 'Legal',
        billing: 'Cash',
        contactName: 'K BJQwX',
        remark: 'What should you include in your message when you\x92re sending an email to a hiring manager to apply for a job? An email cover letter should include the sam',
        address2: '8738 Twin Pines Court',
        address3: '9426 Main Hill',
        address4: '741 Hansons Avenue'
      }
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/customer/_id.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/customer/_id.vue
// module chunks = 64